import React from 'react';
import {
  ModalActionContainer,
  ModalActionContent,
  ModalActionHead,
  ModalActionBody,
  ModalActionBodyIcon,
  ModalActionBodyLabel,
  ModalActionBodyDescription,
  ModalActionFooter,
  ModalActionFooterButton,
} from './styles';
import { IoClose } from 'react-icons/io5';
import colors from '../../assets/styles/colors';

const ModalAction = ({ title, description, open, bodyIcon, rotateIcon, setShowModal, actionFunctionUpButton, actionLabelFunctionUpButton, actionLabelFunctionDownButton, actionFunctionDownButton, backgroundIcon }) => {
  return (
    <ModalActionContainer open={open} id="modal-action">
      <ModalActionContent>
        <ModalActionHead setShowModal={setShowModal}>
          {setShowModal && <IoClose size={26} color={colors.textSecondary} onClick={() => setShowModal(false)} id="close-icon" />}
        </ModalActionHead>
        <ModalActionBody>
          <ModalActionBodyIcon backgroundIcon={backgroundIcon} rotateIcon={rotateIcon}>
            {bodyIcon}
          </ModalActionBodyIcon>
          <ModalActionBodyLabel>
            {title}
          </ModalActionBodyLabel>
          {description && (
            <ModalActionBodyDescription>
              {description}
            </ModalActionBodyDescription>
          )}
        </ModalActionBody>
        <ModalActionFooter>
          {actionLabelFunctionUpButton && (
            <ModalActionFooterButton onClick={() => actionFunctionUpButton()} id="top-action-button">
              {actionLabelFunctionUpButton}
            </ModalActionFooterButton>
          )}
          {actionLabelFunctionDownButton && (
            <ModalActionFooterButton onClick={() => actionFunctionDownButton()} id="bottom-action-button">
              {actionLabelFunctionDownButton}
            </ModalActionFooterButton>
          )}
        </ModalActionFooter>
      </ModalActionContent>
    </ModalActionContainer>
  )
}

export default ModalAction
